export interface IApplicationTechnologyReport {
  labName: string;
  orelapId: string;
  epaId: string;
  labId: number;
  appId: number;
  technologies: IApplicationTechnologyViewModel [];
}

export interface IApplicationTechnologyViewModel {
  name: string;
  instrumentTechnology: string;
  reference: string;
  revision: string;
  title: string;
  status: string;
  air: string;
  biological: string;
  drinkingWater: string;
  nonPotable: string;
  solids: string;
}

export interface IFoaReportViewModel {
  orelapId: string;
  epaId: string;
  labId: number;
  labName: string;
  appId: number;
  matrix: string;
  sortOrder: number;
  methodCode: number;
  methodReference: string;
  revision: string;
  methodTitle: string;
  analyteCode: number;
  analyte: string;
  category: string;
  newStatus: string;
  newStatusDate: Date;
  currentStatus: string;
  currentStatusDate: Date;
  status: string;
  date: string;
}

// Application Reports View Models

export interface IApplicationPersonnelViewModel {
  title: string;
  discipline: string;
  salutation: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  fax: string;
}

export interface IApplicationHoursViewModel {
  day: string;
  startHours: string;
  endHours: string;
}

export interface IApplicationMethodsViewModel {
  name: string;
  instrumentTechnology: string;
  reference: string;
  revision: string;
  air: string;
  drinkingWater: string;
  nonPotable: string;
  biological: string;
  solids: string;
  title: string;
  analyte: string;
}

export interface IApplicationReportViewModel {
  applicationType: string;
  applicationId: number;
  submitter: string;
  submitDate: string;
  datePrinted: string;
  printedBy: string;
  orelapId: string;
  epaId: string;
  laboratoryName: string;
  taxId: string;
  accreditingAuthority: string;
  siteAddress: string;
  siteCity: string;
  siteState: string;
  siteZip: string;
  longitude: string;
  latitude: string;
  mailAddress: string;
  mailCity: string;
  mailState: string;
  mailZip: string;
  billingAddress: string;
  billingCity: string;
  billingState: string;
  billingZip: string;
  ownerName: string;
  ownerAddress: string;
  ownerCity: string;
  ownerState: string;
  ownerZip: string;
  ownerPhone: string;
  labTypeDescription: string;
  labTypeOther: string;
  commercialSamples: string;
  commercialSamplesComments: string;
  drivingDirections: string;
  hoursComments: string;
  weekdays: string;
  applicationMethods: IApplicationMethodsViewModel[];
  applicationHours: IApplicationHoursViewModel[];
  applicationPersonnel: IApplicationPersonnelViewModel[];
}

// Inspection Reports View Models

export interface IInspectionActionsViewModel {
  header: string;
  technology: string;
  questionReferrence: string;
  question: string;
  findings: string;
  caResponseFirst: string;
  inspectorResponseFirst: string;
  caResponseSecond: string;
  inspectorResponseSecond: string;
}

export interface IInspectorsViewModel {
  firstName: string;
  lastName: string;
  email: string;
}

export interface IInspectionSummaryViewModel {
  labName: string;
  orelapId: string;
  assessmentType: string;
  assessmentDate: string;
  summary: string;
  inspectors: IInspectorsViewModel[];
  actions: IInspectionActionsViewModel[][];
}


// Application Fees Report View Models

export interface IApplicationFeeCalculationViewModel {
  title: string;
  labName: string;
  applicationType: string;
  user: string;
  basicMultiplier: number;
  moderateMultiplier: number;
  complexMultiplier: number;
  advancedMultiplier: number;
  miscMultiplier: number;
  basicFots: number;
  moderateFots: number;
  complexFots: number;
  advancedFots: number;
  miscFots: number;
  applicationFee: number;
  assessmentFee: number;
  onSiteFee: number;
  totalFee: number;
  feeTier1: number;
  feeTier2: number;
  feeTier3: number;
  feeTier4: number;
  feeTier5: number;
}

export interface IApplicationFeeReportViewModel {
  orelapId: string;
  applicationId: number;
  category: string;
  fieldOfTesting: string;
  cost: number;
  air: string;
  drinkingWater: string;
  nonPotable: string;
  solids: string;
  biological: string;
  fieldOfTestingSubtotal: number;
}

export interface IApplicationFeeModel {
  orelapId: string;
  applicationId: number;
  appFeeCategory: IApplicationFeeReportViewModel [];
  appFeeData: IApplicationFeeCalculationViewModel;
}

export interface IViewPTResult {
  resultId?: number;
  ptFileId?: number;
  orelapId: string;
  ptProvider: string;
  result: string;
  studyNo: string;
  closeDate?: Date;
  matrix: string;
  methodCode?: number;
  analyteCode?: number;
}

export interface IViewPTAnalyte {
  analyteCode?: number;
  analyte: string;
  methodCode?: number;
  methodDesc: string;
  matrix: string;
  techKey?: number;
  technology: string;
  passed?: boolean;
  results?: IViewPTResult[];
}

export interface IViewPtModel {
  columns: number;
  fromDateTxt?: Date;
  toDateTxt?: Date;
  labName: string;
  orelapId: string;
  results: IViewPTAnalyte[];
}

export interface IViewOsa {
  userId: number;
  orderByTxt: string;
  param1_orderBy: string;
  filterBy: string;
}

export interface ICertificateReportMatrixViewModel {
  name: string;
  matrix: string;
}

export interface ICertificateReportViewModel {
  labName: string;
  orelapId: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  administrator: string;
  certificateFacility: string;
  certificateTitle: string;
  issueDate: string;
  expirationDate: string;
  certificateNumber: string;
  analytes: ICertificateReportMatrixViewModel[];
}

export interface IAttachedReportAnalyteViewModel {
  matrix: string;
  newStatus: string;
  currentStatus: string;
  methodReference: string;
  revision: string;
  methodCode: number;
  methodTitle: string;
  date: string;
  analyteCode: number;
  analyte: string;
}

export interface IAttachedReportViewModel {
  labName: string;
  orelapId: string;
  epaId: string;
  certificateNumber: string;
  siteAddress: string;
  siteCity: string;
  siteState: string;
  siteZip: string;
  issueDate: string;
  expirationDate: string;
  attachedData: IAttachedReportAnalyteViewModel[];
}


